import { useStoreState } from 'pullstate';
import { AppStore } from '../../stores/AppStore';
import { Alert } from '@mui/material';

// Referral link for tracking users we send to Originality.ai.
export const ORIGINALITY_URL = 'https://originality.ai/?via=andrew-passedai';

// Shown at the top of the app for individual (non-institutional) users only.
// Institutional users are transitioned manually and get separate messaging.
function TransitionBanner() {
    const { userDoc } = useStoreState(AppStore);

    if (!userDoc?.uid) return null; // not logged in (e.g. login page)
    if (userDoc?.institutionId || userDoc?.institutionInfo) return null; // institutional — skip

    return (
        <Alert
            severity='info'
            icon={false}
            sx={{
                borderRadius: 0,
                justifyContent: 'center',
                textAlign: 'center',
                backgroundColor: '#1f2641',
                color: '#fff',
                '& a': { color: '#FFC107', fontWeight: 700, textDecoration: 'none' },
            }}
        >
            Passed.ai is joining Originality.ai. Your subscription won&apos;t renew — you can
            keep using Passed.ai until your current period ends.{' '}
            <a href={ORIGINALITY_URL} target='_blank' rel='noopener noreferrer'>
                Visit Originality.ai →
            </a>
        </Alert>
    );
}

export default TransitionBanner;
